module.exports = __webpack_public_path__ + "static/media/ExcelTipo.31a787d0.xlsx";